<template>
  <div>
    <PageTitle :main="$t('manage-indicator')" sub="" imagem="atingirmeta.png" />
    <div class="main-manage">
      <span v-if="blockAll" class="block"></span>
      <div class="select-manage">
        <div>
          <label for="indicator">{{ $t('selecione-uma-acao') + ":" }}</label>
          
          <b-form-group id="indicator-edit" v-slot="{ ariaDescribedby }">
            <b-form-radio-group id="radio-group-2" v-model="actionType" :aria-describedby="ariaDescribedby"
              name="radio-sub-component">
              <b-form-radio id="type-form-new" :disabled="loading" value="new">{{ $t('novo') }}</b-form-radio>
              <b-form-radio id="type-form-edit" :disabled="loading" value="edit">{{ $t('editar') }}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <div class="info-indicator">
            <label for="indicator-selected" class="mb-1">{{ $t('indicador-0') + ": " }}</label>
            <b-icon v-if="(actionType != 'new')" id="indicator-selected" @click="findIndicator" class="icon-find-indicator" icon="search" :title="$t('procurar-indicador')"></b-icon>
            <b-icon v-if="showdiscardStash" @click="$bvModal.show('askDiscardStash')" class="icon-discard-draft" icon="trash" variant="danger" :title="$t('descartar-rascunho')"></b-icon>
            <br>
            <label id="indicator-name" v-if="(actionType == 'new')" class="indicator-large" :title="creatingIndicator">
              <strong>
                {{ (creatingIndicator ? creatingIndicator : $t("nao-definido")) }} <strong v-if="creatingIndicator">[{{ $t('rascunho') }}]</strong>
              </strong>
            </label> 
            <span v-else>
              <strong>
                <label class="indicator-large" :title="indicatorName" @click="findIndicator" for="indicator-selected">{{ indicatorName ? indicatorName : $t("procurar-indicador")  }}</label>
              </strong>
            </span>
          </div>

        </div>
        <b-list-group class="mt-2 menu-list">
          <b-list-group-item id="step-1" @click="selectField" href="#" active>
              <b-badge variant="light" pill>1</b-badge>{{ " - " + $t('caracteristicas') }}
          </b-list-group-item>
          <b-list-group-item id="step-2" @click="selectField" :disabled="blocStep_2" href="#">
            <b-badge variant="light" pill>2</b-badge> {{" - " +  $t('referencia-real') }}
          </b-list-group-item>
          <b-list-group-item id="step-3" @click="selectField" :disabled="blocStep_3" href="#">
            <b-badge variant="light" pill>3</b-badge> {{" - " +  $t('referencia-prevista') }}
          </b-list-group-item>
          <b-list-group-item id="step-4" @click="selectField" :disabled="blocStep_4" href="#">
            <b-badge variant="light" pill>4</b-badge> {{" - " +  $t('posicionamento') }}
          </b-list-group-item>
          <b-list-group-item id="step-5" @click="selectField" :disabled="blocStep_5" href="#">
            <b-badge variant="light" pill>5</b-badge> {{" - " +  $t('gatilhos-para-ocorrencias') }}
          </b-list-group-item>
          <b-list-group-item id="step-6" @click="selectField" :disabled="blocStep_6" href="#">
              <b-badge variant="light" pill>6</b-badge> {{" - " +  $t('resumo') }}
          </b-list-group-item>
        </b-list-group>
        <div class="space-info">
          <b-icon id="stash-indicator" v-if="nameValid" class="icon-button-pentagro mr-2 mt-1" :title="$t('guardar-rascunho')" icon="cloud-upload-fill" @click="saveStash"></b-icon>
          <span class="data-info" v-if="dataInfo">
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm mr-2 ml-2"
              role="status"
              aria-hidden="true"
            ></span>
            <b-icon v-else-if="loading == null" class="icon-error" icon="x-circle" variant="danger"></b-icon>
            <b-icon v-else id="data-ok" class="icon-check" icon="check"></b-icon>
            {{dataInfo}}
          </span>
        </div>
      </div>
      <b-overlay id="overlay-background" class="form-manage" :show="loadingContent" rounded="sm" >    
        <Character v-if="(showFormSelected == 'step-1')"/>
        <CollectedReference v-if="(showFormSelected == 'step-2')"/>
        <CalculatedReference v-if="(showFormSelected == 'step-3')"/>
        <Positioning v-if="(showFormSelected == 'step-4')" :sourceTree="sourceTree"/>
        <Triggers v-if="(showFormSelected == 'step-5')"/>
        <Resume v-if="(showFormSelected == 'step-6')"/>
      </b-overlay>
    </div>
    <b-modal
        id="askDiscardStash"
        ok-variant=danger
        :title="$t('atencao')"
        :ok-title="$t('yes')"
        :cancel-title="$t('no')"
        @ok="discardStash"
        >{{ $t('confirma-descartar-rascunho') }}
      </b-modal>
      <b-modal id="find-indicator" 
        size="lg" 
        :title="$t('procurar-indicador')"
        no-close-on-backdrop
        hide-footer >
        <FindIndicator/> 
      </b-modal>
  </div>
</template>

<script>
import PageTitle from "../../template/PageTitle.vue"
import Character from "./stepPages/step1/Character.vue"
import CollectedReference from "./stepPages/step2/CollectedReference.vue"
import CalculatedReference from "./stepPages/step3/CalculatedReference.vue"
import Positioning from "./stepPages/step4/Positioning.vue"
import Triggers from "./stepPages/step5/Triggers.vue"
import Resume from "./stepPages/step6/Resume.vue"
import FindIndicator from "./FindIndicator.vue"
import Mediator from "./utilities/Mediator"
import axios from 'axios'
import { defaultSuccess, urlMainAPI } from "../../../global"


export default {
  name: "Manage-Indicator",
  components: { 
    PageTitle, 
    Character,
    CalculatedReference,
    CollectedReference,
    Positioning,
    Triggers,
    Resume,
    FindIndicator,
  },
  data() {
    return {
      actionType: "new",
      isNew: true,
      showFormSelected: "step-1",
      indicatorSelected: null,
      indicatorName: "",
      creatingIndicator: "",
      sourceTree: {},
      loading: true,
      loadingContent: false,
      dataInfo: "",
      indicators: [],
      blockAll: false,
      showdiscardStash: false,
      showPrevError: false,
    }
  },

  computed:{
    nameValid() {
      let validName = this.actionType == "edit" && this.indicatorSelected
      validName = this.actionType == "new" && this.creatingIndicator && !this.creatingIndicator.includes(this.$t('nao-definido')) || validName
      return validName
    },
    blocStep_2(){
      return !this.nameValid && true
    }, 
    blocStep_3(){
      return !this.nameValid && true
    }, 
    blocStep_4(){
      return !this.nameValid && true
    }, 
    blocStep_5(){
      return !this.nameValid && true
    },
    blocStep_6(){
      return !this.nameValid && true
    }
  },

  watch:{
    async actionType(value){
      this.isNew = value == "new";
      if(value == "new" && await this.saveStash())
        this.reset()
    },
  },

  methods: {
    findIndicator(){
      this.$bvModal.show('find-indicator')
      setTimeout(() => {
        Mediator.notify(this.indicatorSelected, "findIndicator")
      }, 100);
    },

    canNext(){
      if(this.actionType != "new" && !this.indicatorSelected){
        return false;
      }
      return true;
    },

    async discardStash(){
      this.loadingContent = true
      await axios.get(`${urlMainAPI}/discardStash/${this.indicatorSelected}`).then(async res => {
        if(res.status == 200) {
          defaultSuccess(this.$t("sucesso-deletar-stash"));
          await this.getDataInput()
          this.reset();
          setTimeout(() => this.init(), 200);
        }
      }).catch((e) => {
        console.error(e)
      });
      this.loadingContent = false;
    },

    selectField(target){
      Mediator.notify(target, "select-step")
    },

    reset(){
      this.indicatorName = ""
      document.getElementById("step-1").click();
      this.indicatorSelected = null
      this.creatingIndicator = this.$t('nao-definido')
      Mediator.notify(null, "clear-all")
      Mediator.editing = null;
    },

    async buildStash(target){
      if(!target) return;
      var indicator = null;
      await axios.get(`${urlMainAPI}/buildindicatorstash/${target}`).then(res => {
        if(res.status == 200) {
          indicator = res.data;
        }
      }).catch(console.error);
      this.loadingContent = false
      return indicator;
    },

    async getDataInput(){
      this.dataInfo= "Aguarde...",
      this.loading = true
      await axios.get(`${urlMainAPI}/getindicatorcreationdata`).then(res=> {
        if(res.status == 200){
          Mediator.data = res.data
          this.sourceTree = res.data.indicatorTree;
          let stash = res.data.indicatorsStashed.map(i =>({ value: `${i.id}-${i.productionUnitId}-${i.system}`, text: `${i.indicatorName} [Rascunho]` }))
          this.indicators = res.data.indicators.map(i =>({ value: `${i.id}-${i.productionUnitId}-${i.system}`, text: i.indicatorName }));
          this.indicators.sort((a, b) => a.text > b.text ? 1 : a.text < b.text ? -1 : 0)
          stash.sort((a, b) => a.text > b.text ? 1 : a.text < b.text ? -1 : 0)
          this.indicators = [...stash, ...this.indicators]

          this.loading = false;
          this.dataInfo = this.$t('dados-carregados')

          setTimeout(() => {
            this.dataInfo = ""
          }, 5000);
        }
      }).catch(error => {
        this.dataInfo = this.$t('falha-ao-carregar-os-dados')
        this.loading = null
        console.error(error)
      })
    },

    async saveStash(){
      let result = false;
      if(!Mediator.indicator)
        return
        
      let stash = Mediator.indicator.getStash();
      if(!stash.indicatorName)
        return

      this.loading = true;
      this.dataInfo = "Aguarde..."
      console.log("Saving stash", stash)

      if(!localStorage.tk) return

      await axios.post(`${urlMainAPI}/saveindicatorstash`, stash).then(res => {
        if(res.status == 200){
          result = true
          this.loading = false;
          this.dataInfo = this.$t('rascunho-salvo')
          setTimeout(() => {
            this.loading = true;
            this.dataInfo = this.$t('recarregando-dados')
          }, 1000);
          setTimeout(() => {
            this.dataInfo = ""
            this.getDataInput()
          }, 3000);
        }
      }).catch(error => {
        this.loading = null
        this.dataInfo = this.$t('falha-ao-salvar')
        console.error(error)
      })

      return result;
    },

    async init(){
      await this.getDataInput()
      Mediator.notify(this, "init")
    }
  },

  async created(){
    await this.init();
  },

  destroyed(){
    Mediator.notify(null, "update-indicator");
  }
}
</script>

<style scoped>
.main-manage {
  display: grid;
  grid-template-columns: 20% 80%;
}

.select-manage{
  background-color: #fafafa;
  box-shadow: 0 0 3px #0002;
  border-radius: 4px;
  padding: 8px;
  height: 100%;
}

.block,
.form-manage,
.main-manage{
  height: 70vh;
}
.form-manage{
  display: flex;
  justify-content: center;
  padding: 0px 8px;
  overflow-y: auto;
}

.info-indicator{
  margin-top: 10px;
  height: 55px;
}

.space-info{
  position: absolute;
  bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  z-index: 1;
}

.data-info{
  text-align: center;
  display: flex;
}
.data-info>span{
  position: relative;
  top: 4px;
  color: #ff5f00;
}

.icon-check{
  color: #0d0;
  font-size: 25px;
}

.icon-error{
  color: #d00;
  position: relative;
  top: 4px;
  margin-right: 4px;
  font-size: 15px;
}

.block{
  position: absolute;
  width: 19.8%;
  border-radius: 4px;
  z-index: 10;
  background-color: #00000005;
}

.icon-find-indicator,
.icon-discard-draft{
  margin-left: 8px;
  cursor: pointer;
}

.icon-find-indicator{
  color: #ff5f00;
}

.indicator-large{
  width: 100%; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
}

@media (min-height: 760px) {
  .block,
  .form-manage,
  .main-manage{
    height: 77vh;
  }

  .space-info{
    height: calc(100% - 460px) !important;
  }
}


</style>

<style>
#indicator-edit{
  margin: 0;
}

.menu-list>.list-group-item{
  z-index: 5;
}

.button-pentagro,
.menu-list>.list-group-item.active{
  background-color: #00A39F;
  border-color: #00A39F;
}

.icon-button-pentagro{
  font-size: 25px;
  color: #ff5f00;
  margin: 2px 6px;
  cursor:pointer
}

.icon-button-pentagro:hover{
  color: #ff5f0099;
}

</style>